import {Injectable, OnInit} from '@angular/core';
import {AppService} from "../app.service";
import {URL_API, HEADERS} from "../constante";
import {Report} from "./report";

@Injectable()
export class ReportService extends AppService implements OnInit {

    documentoUrl = URL_API + '/report';

    ngOnInit(): void {
    }

    execute(id, dados: any = ""): Promise<any> {
        // execute(id, dados: any = "") {
        this.spinnerService.show();
        return this.http.post(this.documentoUrl + '/execute/' + id, JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => {
                this.spinnerService.hide();
                return response.json();
            })
            .catch((error) => this.utils.handleError(error));
    }

    gettables(): Promise<any> {
        this.spinnerService.show();
        return this.http.get(URL_API + '/gettables', {headers: HEADERS})
            .toPromise()
            .then(response => {
                this.spinnerService.hide();
                return response.json() as Report;})
            .catch((error) => this.utils.handleError(error));
    }

    getcols(dados: any = ""): Promise<any> {
        this.spinnerService.show();
        return this.http.post(URL_API + '/getcols', JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => {
                this.spinnerService.hide();
                return response.json() as Report;})
            .catch((error) => this.utils.handleError(error));
    }

}



// WEBPACK FOOTER //
// ./src/app/report/report.service.ts